// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__w_BXY","left":"InfoRow_left__E2APk"};